/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Card, Typography, Collapse, Button, List, Space, Input } from "antd";
import { useDispatch, connect, useSelector } from "react-redux";
import * as actions from "./actions";
import { useHistory } from "react-router-dom";
import {
  getReviewAppointments,
  getCurrentPatient,
  getSaveBookingState,
} from "./reducers";
import { getCurrentLocation } from "../Location/reducers";
import Payment from "./Payment";
import {
  ClockCircleTwoTone,
  CalendarTwoTone,
  CreditCardTwoTone,
  SmileTwoTone,
} from "@ant-design/icons";
import { changePatientNote, cancelReservationRequest } from "../Booking/actions";
import { getAvailabilityRequests } from "../Booking/reducers";
import { ButtonSize, lightGrey } from "../../GlobalConfig";
import ContentContainer from "../../components/ContentContainer";
import FullNameWithTitleLabel from "../../components/FullNameWithTitleLabel";
import { isMobile } from "react-device-detect";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;
const { Panel } = Collapse;

function Confirm({
  currentPractice,
  // currentPatient,
  reviewBookingRequest,
  // getPaymentIntent,
  reviewBookings,
  match,
  // location,
  saveBookingRequest,
  saveBookingState,
  startBookingProcess,
  availabilityRequests,
  // toggleItem,
  deleteRequestsUnlessValidSlot,
  openPaymentDrawer,
}) {
  const { params } = match;

  const history = useHistory();
  const dispatch = useDispatch();
  const patientNote = useSelector((state) => state.booking.patientNote)

  React.useEffect(() => {
    reviewBookingRequest(params.locationId);
    // if (currentPatient) {
    //   getPaymentIntent(params.locationId, currentPatient.id);
    // }
    deleteRequestsUnlessValidSlot();
  }, []);

  const serviceTotal = React.useMemo(() => {
    let sumTotal = 0;

    if (!reviewBookings) return sumTotal;

    reviewBookings.map(({ appointmentReason }) => {
      return (sumTotal += appointmentReason.onlineBookingsPrice);
    });

    return sumTotal;
  }, [reviewBookings]);

  const surcharge = React.useMemo(() => {
    let sumTotal = 0;

    if (!reviewBookings) return sumTotal;

    reviewBookings.map(({ appointmentReason }) => {
      return (sumTotal += appointmentReason.onlineBookingsPrice);
    });

    return (
      sumTotal * currentPractice.stripeZavyFee + currentPractice.stripeBaseFee
    );
  }, [reviewBookings]);

  const totalWithSurcharge = React.useMemo(() => {
    let sumTotal = 0;

    if (!reviewBookings) return sumTotal;

    reviewBookings.map(({ appointmentReason }) => {
      return (sumTotal += appointmentReason.onlineBookingsPrice);
    });

    if (currentPractice?.applyPatientSurcharge) {
      return (
        sumTotal +
        (sumTotal * currentPractice.stripeZavyFee +
          currentPractice.stripeBaseFee)
      );
    }

    return sumTotal;
  }, [reviewBookings]);

  const handleMaybePay = React.useCallback(() => {
    if (currentPractice.canReceiveOnlinePayments && serviceTotal > 0) {
      openPaymentDrawer();
    } else {
      dispatch(startBookingProcess());

      saveBookingRequest(
        { ...params, patientNote },
        currentPractice?.successUrl
      );
    }
  }, [currentPractice, serviceTotal, patientNote]);

  const confirmationButtonText = React.useMemo(
    () =>
      currentPractice.canReceiveOnlinePayments && serviceTotal > 0
        ? "Pay and Confirm"
        : "Confirm Booking",
    [currentPractice, serviceTotal]
  );

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    dispatch(changePatientNote(e.target.value));
  };

  const handleGoBack = React.useCallback(() => {
    dispatch(cancelReservationRequest(currentPractice.id, availabilityRequests));
    history.go(-history.length + 1)
  }, []);

  return (
    <ContentContainer
      pageTitle="Review"
      step="5"
      themeColor={currentPractice?.themeColor}
      stepPercentage="90"
      showNext={false}
      extra={
        reviewBookings &&
        reviewBookings &&
        reviewBookings.length > 0 && (
          <Button
            size={ButtonSize}
            style={{
              backgroundColor: currentPractice?.themeColor,
              borderColor: currentPractice?.themeColor,
            }}
            loadingState={saveBookingState}
            loading={saveBookingState}
            type="primary"
            onClick={() => handleMaybePay()}
          >
            {confirmationButtonText}
          </Button>
        )
      }
      backButton={
        <Button
          type="text"
          shape="circle"
          onClick={() => {
            handleGoBack();
          }}
          icon={<ArrowLeftOutlined />}
        />
      }
    >
      <Payment
        practiceId={params.locationId}
        {...{ serviceTotal, surcharge, totalWithSurcharge }}
      />

      <Card
        extra={
          !isMobile &&
          reviewBookings &&
          reviewBookings &&
          reviewBookings.length > 0 && (
            <Button
              size={ButtonSize}
              style={{
                backgroundColor: currentPractice?.themeColor,
                borderColor: currentPractice?.themeColor,
              }}
              loadingState={saveBookingState}
              loading={saveBookingState}
              type="primary"
              onClick={() => handleMaybePay()}
            >
              {confirmationButtonText}
            </Button>
          )
        }
        headStyle={{ background: lightGrey }}
        title="Please check your booking details"
      >
        <List>
          {reviewBookings?.map(
            ({ practitioner, appointmentReason, date, startTime }) => (
              <List.Item key={`${startTime}-${appointmentReason}`}>
                <Space direction="vertical">
                  <Title style={{ padding: 0, margin: 0 }} level={4}>
                    {appointmentReason.name}{" "}
                  </Title>
                  {appointmentReason.description > null && (
                    <Text type="secondary">
                      {appointmentReason.description}
                    </Text>
                  )}
                  <Space size="large" wrap>
                    <Space size={4}>
                      <CalendarTwoTone
                        twoToneColor={currentPractice?.themeColor}
                      />
                      {date}
                    </Space>

                    <Space size={4}>
                      <Text>
                        <ClockCircleTwoTone
                          twoToneColor={currentPractice?.themeColor}
                        />{" "}
                        {startTime}
                      </Text>
                      {appointmentReason.minutes > 0 && (
                        <Text type="secondary">
                          for {appointmentReason.minutes} Mins{" "}
                        </Text>
                      )}
                    </Space>

                    {appointmentReason.requireDeposit &&
                      appointmentReason?.onlineBookingsPrice > 0 ? (
                      <Space size={4}>
                        <CreditCardTwoTone
                          twoToneColor={currentPractice?.themeColor}
                        />
                        ${appointmentReason.onlineBookingsPrice?.toFixed(2)}
                      </Space>
                    ) : (
                      appointmentReason?.showTotalCost && (
                        <Space size={4}>
                          <CreditCardTwoTone
                            twoToneColor={currentPractice?.themeColor}
                          />
                          ${appointmentReason.price?.toFixed(2)}
                        </Space>
                      )
                    )}

                    <Space size={4}>
                      <SmileTwoTone
                        twoToneColor={currentPractice?.themeColor}
                      />{" "}
                      <FullNameWithTitleLabel
                        name={practitioner.fullNameWithTitle}
                      />
                    </Space>
                    {appointmentReason.description > null && (
                      <Collapse ghost defaultActiveKey="1">
                        <Panel header="Additional Info" key="1" />
                      </Collapse>
                    )}
                  </Space>
                </Space>
              </List.Item>
            )
          )}
        </List>{" "}
        {currentPractice?.termsAndConditions && (
          <div style={{ marginTop: 24, marginBottom: 24 }}>
            <Typography.Text type="secondary">
              Terms and Conditions
            </Typography.Text>
            <Card
              size="small"
              bodyStyle={{
                background: lightGrey,
                borderRadius: 4,
              }}
            >
              <span
                // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                dangerouslySetInnerHTML={{
                  __html: currentPractice.termsAndConditions,
                }}
              />
            </Card>
          </div>
        )}
        <Typography.Text type="secondary">Booking notes</Typography.Text>
        <Input.TextArea
          value={patientNote}
          onChange={onChange}
          rows={4}
          placeholder="When booking online, please add any specific details or preferences here. This helps our staff prepare for your visit. Thank you."
          maxLength={250}
          showCount
          style={{ resize: "none", marginBottom: 24 }}
        />
      </Card>
    </ContentContainer>
  );
};

const mapStateToProps = (state) => ({
  reviewBookings: getReviewAppointments(state.booking),
  currentPractice: getCurrentLocation(state.locations),
  saveBookingState: getSaveBookingState(state.booking),
  availabilityRequests: getAvailabilityRequests(state.booking),
  currentPatient: getCurrentPatient(state.booking),
});

export default connect(mapStateToProps, {
  ...actions,
  // toggleItem,
  // deleteRequestsUnlessValidSlot,
  // openPaymentDrawer,
})(Confirm);
